import { createI18n } from "vue-i18n/dist/vue-i18n.esm-bundler.js";
import DateTimeFormats from "./locales/date-time-formats";

// File autogenerated by "vue add i18n".
// See DOS-1840.

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default createI18n({
  allowComposition: true,
  locale: 'en',
  fallbackLocale: 'en',
  globalInjection: true,
  messages: loadLocaleMessages(),
  warnHtmlInMessage: 'off', // https://github.com/intlify/vue-i18n-next/issues/853
  datetimeFormats: DateTimeFormats,
})
